import React, { useState } from 'react';

import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiSelect from '@material-ui/core/Select';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiTextField from '@material-ui/core/TextField';
import MuiAutocomplete from '@material-ui/lab/Autocomplete';
import MuiHighlightOffIcon from '@material-ui/icons/HighlightOff';
import { WithTooltip } from 'utils/wrappers';
import MuiIconButton from '@material-ui/core/IconButton';

function EditSplitRow({ idx, split, updateValues, removeSplit, payees, contributors, colDefs }) {
  const [formValue, setFormValue] = useState({
    ...split,
  });
  const [payeeEmail, setPayeeEmail] = useState(getPayeeEmail(split, payees));
  const [selectedPayee, setSelectedPayee] = useState(getPayee(split, payees));

  function onChangePayee(_e, value) {
    if (!value) return;
    setPayeeEmail(value.payment_account?.group?.email || value.payment_account?.user?.email);
    setSelectedPayee(value);
    formChanges('user_group_payee_id', value.user_group_payee_id);
  }

  function formChanges(key, value) {
    const newValues = { ...formValue, [key]: value };
    setFormValue(newValues);
    updateValues(idx, newValues);
  }

  return (
    <MuiTableRow>
      <MuiTableCell {...colDefs[0].cellProps}>{split.id}</MuiTableCell>
      <MuiTableCell {...colDefs[1].cellProps}>
        <MuiAutocomplete
          disablePortal
          options={['', ...payees]}
          getOptionLabel={payee => payee?.payment_account?.group?.name || payee?.payment_account?.user?.name || ''}
          getOptionSelected={(option, value) => option.user_group_payee_id === value.user_group_payee_id}
          onChange={onChangePayee}
          value={selectedPayee || ''}
          renderInput={params => <MuiTextField {...params} label="Payee" variant="outlined" size="small" />}
        />
      </MuiTableCell>
      <MuiTableCell {...colDefs[2].cellProps}>{payeeEmail}</MuiTableCell>
      <MuiTableCell {...colDefs[3].cellProps}>
        <MuiSelect
          label="Contributor"
          value={formValue.asset_party_id || ''}
          onChange={({ target: { value } }) => formChanges('asset_party_id', value)}
          style={{ width: '100%' }}>
          <MuiMenuItem key="empty" value=""></MuiMenuItem>
          {contributors?.map(({ full_name, asset_party_id }) => (
            <MuiMenuItem key={asset_party_id} value={asset_party_id}>
              {full_name}
            </MuiMenuItem>
          ))}
        </MuiSelect>
      </MuiTableCell>
      <MuiTableCell {...colDefs[4].cellProps}>
        <MuiSelect
          label={'Role'}
          style={{ width: '100%' }}
          value={formValue.roles[0] || ''}
          onChange={({ target: { value } }) => formChanges('roles', [value])}>
          {ROLES.map(role => (
            <MuiMenuItem key={role} value={role}>
              {role}
            </MuiMenuItem>
          ))}
        </MuiSelect>
      </MuiTableCell>
      <MuiTableCell {...colDefs[5].cellProps}>
        <MuiTextField
          value={split.payee_payment_account_wallet_address}
          onChange={({ target: { value } }) => formChanges('payee_payment_account_wallet_address', value)}
          inputProps={{
            maxLength: 42,
          }}
        />
      </MuiTableCell>
      <MuiTableCell {...colDefs[6].cellProps}>
        <MuiTextField
          type="number"
          value={Number(formValue.percentage) || 0}
          onChange={({ target: { value } }) => formChanges('percentage', value)}
        />
      </MuiTableCell>
      <MuiTableCell>
        <WithTooltip tooltip="Remove Split">
          <MuiIconButton onClick={() => removeSplit(idx)}>
            <MuiHighlightOffIcon />
          </MuiIconButton>
        </WithTooltip>
      </MuiTableCell>
    </MuiTableRow>
  );
}

export default EditSplitRow;

const ROLES = [
  '',
  'Artist',
  'Band',
  'Composer',
  'ComposerLyricist',
  'Contributor',
  'FeaturedArtist',
  'Label',
  'Lyricist',
  'MainArtist',
  'Management',
  'PrimaryMusician',
  'Producer',
  'Soloist',
  'StudioPersonnel',
];

function getPayeeEmail(split, payees) {
  const payee = getPayee(split, payees);
  return payee?.payment_account?.group?.email || payee?.payment_account?.user?.email;
}

function getPayee(split, payees) {
  return payees.find(p => split.user_group_payee_id === p.user_group_payee_id);
}
